import React from 'react'

const Mail = props => (
  <svg viewBox="0 0 77 60" {...props}>
    <path
      d="M71.057 53.182V20.455a22.959 22.959 0 0 1-2.946 2.811c-6.106 4.689-12.255 9.461-18.19 14.403-3.204 2.684-7.175 5.967-11.616 5.967h-.085c-4.44 0-8.412-3.28-11.615-5.967-5.936-4.944-12.085-9.717-18.19-14.403a22.967 22.967 0 0 1-2.946-2.811v32.727c0 .725.64 1.363 1.366 1.363h62.858c.727 0 1.367-.638 1.367-1.363h-.003zm0-44.787c0-1.067.257-2.94-1.367-2.94H6.832c-.727 0-1.366.638-1.366 1.363 0 4.857 2.435 9.077 6.278 12.104A2678.626 2678.626 0 0 1 28.868 32.43c2.263 1.833 6.363 5.752 9.352 5.752h.085c2.99 0 7.09-3.92 9.352-5.752 5.68-4.516 11.402-9.035 17.125-13.508 2.777-2.174 6.278-6.903 6.278-10.525l-.003-.002zm5.466-1.577v46.364c0 3.75-3.075 6.818-6.833 6.818H6.832C3.075 60 0 56.932 0 53.182V6.818C0 3.068 3.075 0 6.832 0H69.69c3.758 0 6.833 3.068 6.833 6.818z"
      fill="#FFF"
    />
  </svg>
)

export default Mail



// WEBPACK FOOTER //
// ./src/components/Icons/Mail.js